import AdBanner from './AdBanner';

/** Right-column sidebar ad for airport pages — delegates to AdBanner. */
export default function ExpediaBanner() {
  return <AdBanner variant="sidebar" />;
}
